module.exports = __webpack_public_path__ + "img/undraw_Control_panel_re_y3ar.81dbabd4.png";